import React, { FC, ReactNode } from 'react';
import {
  OBJECTIVE_ICONS,
  PROFITABLE_DAYS_CONSTANTS,
} from '@hub/features/account-dashboard/components/sections/dashboard-header/components/objective-list/constants';
import { Box, Stack, Typography } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tooltip } from '@monorepo/nova-ui';

interface WidgetItemProps {
  primaryText: ReactNode;
  secondaryText: ReactNode;
  tooltipText?: string | ReactNode;
  icon: ReactNode;
}

export const WidgetItem: FC<WidgetItemProps> = ({
  primaryText,
  secondaryText,
  tooltipText,
  icon,
}) => {
  return (
    <Stack
      spacing={2}
      alignItems="flex-start"
      sx={(theme) => ({
        width: {
          xs: `calc(50% - ${theme.typography.pxToRem(4)})`,
          sm: theme.typography.pxToRem(140),
          md: theme.typography.pxToRem(160),
        },
        minWidth: {
          xs: `calc(50% - ${theme.typography.pxToRem(4)})`,
          sm: theme.typography.pxToRem(140),
          md: theme.typography.pxToRem(160),
        },
        height: {
          xs: 'auto',
        },
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        gap={{
          xs: 2,
          sm: 3,
        }}
        sx={(theme) => ({
          color: theme.palette.text.second,
          '& svg, svg path, svg g, svg rect': {
            fill: theme.palette.text.second,
            stroke: theme.palette.text.second,
            strokeWidth: 0,
          },
        })}
      >
        {icon}
        <Typography
          variant="body2"
          textAlign="center"
          sx={(theme) => ({
            fontSize: {
              xs: theme.typography.pxToRem(12),
              sm: theme.typography.pxToRem(14),
            },
            whiteSpace: { xs: 'normal', sm: 'nowrap' },
            color: theme.palette.text.second,
          })}
        >
          {primaryText}
        </Typography>

        {tooltipText && (
          <Tooltip title={tooltipText}>
            <Stack>
              <SystemIcon
                iconName={OBJECTIVE_ICONS.INFO}
                size={PROFITABLE_DAYS_CONSTANTS.INFO_ICON_SIZE}
                sx={{
                  opacity: 0.6,
                }}
              />
            </Stack>
          </Tooltip>
        )}
      </Stack>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {secondaryText}
      </Box>
    </Stack>
  );
};
